/* MOTO-DOC · panier : cadeaux par paliers + suggestions liées à la moto du garage */
(function () {
  if (window.__motoCart) return;
  window.__motoCart = true;

  var YMM_KEY = 'motodoc_ymm';
  var cache = {};

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function isCartPage() { return !!document.getElementById('main-cart-items'); }

  /* ---------- Rafraîchit le tiroir (ou recharge la page panier) ---------- */
  function refresh() {
    if (isCartPage()) { location.reload(); return Promise.resolve(); }
    return Promise.all([
      getJSON('/?sections=cart-drawer,cart-icon-bubble'),
      getJSON('/cart.js')
    ]).then(function (res) {
      var secs = res[0], cart = res[1];
      var drawer = $('#CartDrawer');
      if (drawer && secs['cart-drawer']) {
        var doc = new DOMParser().parseFromString(secs['cart-drawer'], 'text/html');
        var src = doc.querySelector('#CartDrawer');
        if (src) drawer.innerHTML = src.innerHTML;
        var ov = $('#CartDrawer-Overlay');
        var cd = $('cart-drawer');
        if (ov && cd && cd.close) ov.addEventListener('click', cd.close.bind(cd));
        if (cd) cd.classList.toggle('is-empty', cart.item_count === 0);
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && secs['cart-icon-bubble']) {
        var d2 = new DOMParser().parseFromString(secs['cart-icon-bubble'], 'text/html');
        var s2 = d2.querySelector('.shopify-section');
        if (s2) bubble.innerHTML = s2.innerHTML;
      }
      $$('.totals__items').forEach(function (el) { el.textContent = cart.item_count; });
    });
  }

  /* ---------- Clics : cadeau + ajout suggestion + flèches ---------- */
  document.addEventListener('click', function (e) {
    var g = e.target.closest('[data-moto-gift]');
    if (g) {
      e.preventDefault();
      if (g.disabled) return;
      g.disabled = true;
      var sel = g.parentNode && g.parentNode.querySelector('[data-moto-gift-select]');
      post('/cart/add.js', { id: Number(sel ? sel.value : g.getAttribute('data-moto-gift')), quantity: 1 })
        .then(function (r) { if (r && r.status) { g.disabled = false; return; } return refresh(); })
        .catch(function () { g.disabled = false; });
      return;
    }
    var a = e.target.closest('[data-moto-add]');
    if (a) {
      e.preventDefault();
      if (a.disabled) return;
      a.disabled = true;
      post('/cart/add.js', { id: Number(a.getAttribute('data-moto-add')), quantity: 1 })
        .then(function (r) { if (r && r.status) { a.disabled = false; return; } return refresh(); })
        .catch(function () { a.disabled = false; });
      return;
    }
    var p = e.target.closest('[data-mc-prev]');
    var n = e.target.closest('[data-mc-next]');
    if (p || n) {
      var box = (p || n).closest('[data-moto-upsell]');
      if (box) { move(box, p ? -1 : 1); }
    }
  });

  /* ---------- Cadeaux à retirer / limiter ---------- */
  function runFix() {
    var els = $$('[data-moto-fix]:not([data-done])');
    if (!els.length) return;
    els.forEach(function (el) { el.setAttribute('data-done', '1'); });
    try {
      var last = Number(sessionStorage.getItem('mc_fix') || 0);
      if (Date.now() - last < 4000) return;
      sessionStorage.setItem('mc_fix', String(Date.now()));
    } catch (_) {}
    var seen = {};
    var chain = Promise.resolve();
    els.forEach(function (el) {
      var key = el.getAttribute('data-key');
      if (seen[key]) return;
      seen[key] = 1;
      chain = chain.then(function () {
        return post('/cart/change.js', { id: key, quantity: Number(el.getAttribute('data-qty')) });
      });
    });
    chain.then(refresh).catch(function () {});
  }

  /* ---------- Carrousel ---------- */
  function perView(box) {
    var v = parseInt(getComputedStyle(box).getPropertyValue('--mc-per-view'), 10);
    return v > 0 ? v : 1;
  }
  function move(box, dir) {
    var track = $('[data-mc-track]', box);
    var count = track.children.length;
    var pv = perView(box);
    var max = Math.max(0, count - pv);
    var idx = Math.min(max, Math.max(0, (Number(box._idx) || 0) + dir));
    box._idx = idx;
    track.style.transform = 'translateX(' + (-idx * 100 / pv) + '%)';
    var prev = $('[data-mc-prev]', box), next = $('[data-mc-next]', box);
    if (prev) prev.disabled = idx === 0;
    if (next) next.disabled = idx >= max;
  }
  function card(it) {
    var img = it.image ? '<img class="mc-card__img" src="' + esc(it.image) + '" alt="" loading="lazy" width="84" height="84">' : '';
    var btn = it.single
      ? '<button type="button" class="mc-btn mc-btn--sm" data-moto-add="' + it.variant + '">Ajouter</button>'
      : '<a class="mc-btn mc-btn--sm mc-btn--ghost" href="' + esc(it.url) + '">Voir les options</a>';
    return '<div class="mc-slide"><div class="mc-card">' + img +
      '<div class="mc-card__body"><a class="mc-card__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
      '<span class="mc-card__price">' + esc(it.price) + '</span>' + btn + '</div></div></div>';
  }
  function fetchItems(path) {
    if (cache[path]) return Promise.resolve(cache[path]);
    return getJSON(path + '?view=moto-upsell&sort_by=best-selling').then(function (list) {
      cache[path] = list;
      return list;
    });
  }
  function hydrate(box) {
    box.setAttribute('data-ready', '1');
    var moto = null;
    try { moto = JSON.parse(localStorage.getItem(YMM_KEY) || 'null'); } catch (_) {}
    var sources = [];
    if (moto && moto.tag) {
      sources.push({ path: '/collections/' + (box.getAttribute('data-moto-collection') || 'all') + '/' + moto.tag, moto: true });
    }
    sources.push({ path: '/collections/' + (box.getAttribute('data-fallback') || 'all'), moto: false });

    getJSON('/cart.js').then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      (function next(i) {
        if (i >= sources.length) return;
        fetchItems(sources[i].path).then(function (list) {
          var items = list.filter(function (x) { return x.available && x.cents > 0 && !inCart[x.id]; }).slice(0, 10);
          if (!items.length) return next(i + 1);
          show(box, items, sources[i].moto ? moto : null);
        }).catch(function () { next(i + 1); });
      })(0);
    }).catch(function () {});
  }
  function show(box, items, moto) {
    var title = $('[data-mc-title]', box);
    if (title) {
      title.textContent = moto && moto.make
        ? 'Compatible avec votre ' + moto.make + ' ' + (moto.model || '')
        : (box.getAttribute('data-title') || 'Pour compléter votre commande');
    }
    var track = $('[data-mc-track]', box);
    track.innerHTML = items.map(card).join('');
    box._idx = 0;
    box.hidden = false;
    var nav = $('.mc-upsell__nav', box);
    if (nav) nav.style.display = items.length > perView(box) ? '' : 'none';
    move(box, 0);
  }

  window.addEventListener('resize', function () {
    $$('[data-moto-upsell][data-ready]').forEach(function (b) { if (!b.hidden) move(b, 0); });
  });
  document.addEventListener('ymm:change', function () {
    $$('[data-moto-upsell]').forEach(function (b) { b.removeAttribute('data-ready'); });
    scan();
  });

  /* ---------- Page panier : met à jour la barre de paliers ---------- */
  function refreshPageRewards() {
    $$('[data-moto-rewards][data-section-id]').forEach(function (el) {
      if (el.closest('#CartDrawer')) return;
      fetch(location.pathname + '?section_id=' + encodeURIComponent(el.getAttribute('data-section-id')))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var n = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-moto-rewards]');
          if (n) el.replaceWith(n); else el.remove();
        }).catch(function () {});
    });
  }
  function bindPubSub() {
    if (window.subscribe && window.PUB_SUB_EVENTS && !window.__motoCartBound) {
      window.__motoCartBound = true;
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshPageRewards);
    }
  }

  function scan() {
    runFix();
    $$('[data-moto-upsell]:not([data-ready])').forEach(hydrate);
  }
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(scan, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () { scan(); bindPubSub(); });
  window.addEventListener('load', bindPubSub);
  if (document.readyState !== 'loading') { scan(); bindPubSub(); }
})();
